import React, { useState } from "react";
import { FreeSwitchDevelopersFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const FreeSwitchDevelopers = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };
  const scrollToContact = () => {
    document
      .getElementById("contact-section")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (<>
    <Helmet>
      <meta name="description" content="Hire skilled FreeSWITCH developers in India to build reliable, scalable, and custom VoIP solutions. Get expert FreeSWITCH development for your business growth." />
<meta name="copyright" content="codeglim"/>
<meta property="og:title" content="Hire Skilled FreeSWITCH Developers in India | Ayanshtech Solutions"/>
<meta property="og:site_name" content="Ayanshtech Solutions"/>
<meta property="og:url" content="https://ayanshtechnology.com/hire-freeswitch-developers"/>
<meta property="og:description" content="Hire skilled FreeSWITCH developers in India to build reliable, scalable, and custom VoIP solutions. Get expert FreeSWITCH development for your business growth."/>
<meta property="og:type" content="website"/>
<meta property="og:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<meta name="twitter:card" content="summary"/>
<meta name="twitter:site" content="@Ayanshtech Solutions"/>
<meta name="twitter:title" content="Hire Skilled FreeSWITCH Developers in India | Ayanshtech Solutions"/>
<meta name="twitter:description" content="Hire skilled FreeSWITCH developers in India to build reliable, scalable, and custom VoIP solutions. Get expert FreeSWITCH development for your business growth."/>
<meta name="twitter:image" content="https://ayanshtechnology.com/assets/logo.png"/>

<link rel="canonical" href="https://ayanshtechnology.com/hire-freeswitch-developers"/>
<title>Hire Skilled FreeSWITCH Developers in India | Ayanshtech Solutions</title></Helmet>

    <div className="min-h-screen flex flex-col items-center justify-center p-6 gradient-background">
      <div className="  w-full">
        <div className="flex flex-col lg:flex-row items-center lg:space-x-16  mt-10">
          <div className="lg:w-3/4  lg:text-left p-4">
            <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
              Hire Skilled FreeSWITCH Developers in India
            </h1>
            <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
              FreeSWITCH stands as a robust, open-source telecommunication
              platform that empowers businesses to create custom communication
              solutions with exceptional flexibility. Whether you’re looking to
              build VoIP systems, PBX platforms, or conferencing tools,
              FreeSWITCH provides the scalability and modular design necessary
              to meet diverse business requirements.
              <br /> <br />
              At Ayanshtech, our team of seasoned FreeSWITCH developers
              specializes in leveraging the full potential of this platform to
              design, implement, and optimize tailored communication systems. We
              excel in delivering customized solutions, including SIP-based
              communication, real-time collaboration tools, and multi-tenant
              architectures for enterprises of all sizes.
              <br /> <br />
              By hiring our expert FreeSWITCH developers, you gain access to
              in-depth expertise, seamless integration capabilities, and
              innovative features that enhance communication performance and
              reliability. Experience the power of cutting-edge technology and
              take your business communication to the next level with our
              trusted FreeSWITCH development services.
            </p>
            <p className="  text-gray-600 sm:text-lg md:text-xl lg:text-xl">
              Starting from just <span className="font-bold">US $18/hour</span>
            </p>
            <button
              onClick={scrollToContact}
              className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold p-3 rounded-full mt-6"
            >
              Hire a FreeSWITCH Developer
            </button>
          </div>

          <div className="flex justify-center  mb-12 lg:mb-0 ">
            <img
              src="\assets\images\headerSection\hireFreeSwitchDev\img1.png"
              alt="VoIP Business Solutions"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="text-center  mt-10">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Skills of Our FreeSWITCH Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Ayanshtech Solutions offers end-to-end FreeSWITCH development
          services, including custom module creation and system enhancements.
        </p>
      </div>
      <div className=" p-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon9.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Proficiency in configuring multi-tenant FreeSWITCH environments
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon8.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Skilled in integrating FreeSWITCH with external APIs and databases
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon7.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Expertise in implementing secure VoIP communication systems
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon6.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Advanced knowledge of WebRTC integration with FreeSWITCH
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon5.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Experience with FreeSWITCH scaling and load balancing
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon4.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Ability to develop custom FreeSWITCH event handlers and scripts
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon3.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Expertise in troubleshooting and optimizing FreeSWITCH performance
            </p>
          </div>

          <div className="flex items-center space-x-4">
            <img
              src="\assets\icons\techIcons\icon2.png"
              alt="icon"
              className="w-10 h-10"
            />
            <p className="text-lg">
              Extensive knowledge of call routing and session management in
              FreeSWITCH
            </p>
          </div>
        </div>
      </div>

      <div className="text-center mb-5 mt-20">
        <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
          Hire Expert FreeSWITCH Developers
        </h2>
        <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
          Let our FreeSWITCH professionals turn your vision into reality with
          innovative solutions.
        </p>
      </div>

      <div className=" p-4">
        <div className="flex flex-col md:flex-row items-center justify-between">
          <div className="w-full md:w-1/3 p-4">
            <img
              src="\assets\images\headerSection\hirefreeSwitchDev\img2.png"
              alt="Laptop with analytics"
              className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
            />
          </div>

          <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon9.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Extensive experience in building telecom solutions
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon8.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Proficiency in multi-tenant architecture
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon7.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Agile methodology for FreeSWITCH solution development
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon6.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Flexible and dynamic team for diverse communication needs
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon5.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Quick delivery of technological solutions
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <img
                src="\assets\icons\techIcons\icon4.png"
                alt="icon"
                className="w-10 h-10"
              />
              <div>
                <p className="text-lg">
                  Skilled professionals with extensive training
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AyanshtechAdvantage />

      {/* <div className="max-w-3xl mx-auto p-4  w-full ">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
          FAQs
        </h2>
        {FreeSwitchDevelopersFaqs.map((faq, index) => (
          <div key={index} className="border-b-2 border-blue-300">
            <button
              onClick={() => toggleFAQ(index)}
              className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                activeIndex === index
                  ? "bg-blue-600 text-white px-5 rounded-2xl"
                  : ""
              }`}
            >
              <span className="text-lg">{faq.question}</span>
              <span className="text-2xl">
                {activeIndex === index ? "-" : "+"}
              </span>
            </button>
            {activeIndex === index && (
              <div className="p-4 text-gray-700">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>

      <div id="contact-section">
        {" "}
        <Contact />
      </div> */}

       <div className="h-[30px] md:h-[60px] lg:h-[80px]"></div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-16">
                FAQs
            </h2>
            <div className="flex flex-col md:flex-row justify-around mb-5  md:mb-4 lg:mb-5 item-center ">

                <div className="w-full  md:w-1/2 lg:w-[616px]  mb-8 md:mb-4 lg:mb-0">
                    {/* <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
                        FAQs
                    </h2> */}
                    {FreeSwitchDevelopersFaqs.map((faq, index) => (
                        <div key={index} className="border-b-2 border-blue-300">
                            <button
                                onClick={() => toggleFAQ(index)}
                                className={` w-full text-left py-4 flex justify-between items-center focus:outline-none ${activeIndex === index
                                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                                    : ""
                                    }`}
                            >
                                <span className="text-lg">{faq.question}</span>
                                <span className="text-2xl">
                                    {activeIndex === index ? "-" : "+"}
                                </span>
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 text-gray-700">{faq.answer}</div>
                            )}
                        </div>
                    ))}
                </div>

                <div id="contact-section" className="w-full md:w-1/2 lg:w-1/2">
                    {" "}
                    <Contact />
                </div>


            </div>

      <GetInTouch />
    </div>
  </>);
};

export default FreeSwitchDevelopers;
